import { useEffect } from 'react';
import { io } from 'socket.io-client';
import config from 'config';

const socket = io(config.webSocketUrl, { autoConnect: false });

export default function useSocketEvents(events, userId, source) {
  // the effect for connecting and disconnecting the socket
  useEffect(() => {
    if (!userId) return;

    socket.auth = { userId };
    socket.connect();

    function onConnect() {
      console.log(`Socket ${socket.id} connected for user: ${userId}. Source: ${source}`);
    }

    function onDisconnect(reason) {
      const logMessageStart = `Socket disconnected for user: ${userId}. Reason: ${reason}. Source: ${source}`;

      if (socket.active) {
        console.log(`${logMessageStart} Will try to reconnect automatically...`);
      } else {
        console.log(`${logMessageStart}`);
      }
    }

    function onConnectError(error) {
      const logMessageStart = `Socket "connect_error" for user: ${userId}. Error: ${error.message}.`;

      if (socket.active) {
        console.log(`${logMessageStart} Will try to reconnect automatically...`);
      } else {
        console.log(`${logMessageStart}`);
      }
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('connect_error', onConnectError);

    return () => {
      socket.disconnect();

      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('connect_error', onConnectError);
    };
  }, [userId]);

  // the effect for adding and removing custom event listeners
  useEffect(() => {
    events.forEach(({ type, handler }) => {
      socket.on(type, handler);
    });

    return () => {
      events.forEach(({ type, handler }) => {
        socket.off(type, handler);
      });
    };
  }, [events]);
};